import { FormControl, FormHelperText, FormLabel, Select } from '@mui/material';
import { Controller } from 'react-hook-form';

export default function UseFormSelect({
  children,
  control,
  name,
  label,
  error,
  helperText,
  hiddenLabel = false,
  required = false,
  asNumber = false,
  disabled = false,
  placeholder,
  ...props
}: any) {
  return (
    <FormControl error={error} {...props}>
      {label && !hiddenLabel && (
        <FormLabel>
          {label} {required && '*'}
        </FormLabel>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => {
          const emptyProps = {
            displayEmpty: true,
            renderValue: () => placeholder,
          };
          const additionalProps = value == null ? emptyProps : {};

          return (
            <Select
              disabled={disabled}
              value={value}
              onChange={(event: any) =>
                onChange(asNumber ? +event.target.value : event.target.value)
              }
              {...additionalProps}
            >
              {children}
            </Select>
          );
        }}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
